import React from 'react';
import {
  compose,
  withState,
  withStateHandlers,
  withPropsOnChange,
} from 'recompose';
import { ChromePicker } from 'react-color';

import withField from '../withField';
import withClickOutside from 'lib/withClickOutside';
import cx from 'classnames';

import styles from './styles.css';
import { Input } from '../Input';

const Picker = withClickOutside(({ onClose }) => onClose())((props) => (
  <div className={styles.picker}>
    <ChromePicker {...props} />
  </div>
));

export const ColorPicker = compose(
  withStateHandlers(
    ({ value, defaultValue }) => ({
      color: defaultValue || value,
      isOpen: false,
    }),
    {
      showPicker: (s) => () => ({ ...s, isOpen: true }),
      hidePicker: (s) => () => ({ ...s, isOpen: false }),
      resetColor:
        ({ color, ...s }) =>
        () => ({ ...s, color: '' }),
      setColor:
        (s, { onChange, ...props }) =>
        (color) => {
          onChange(color.hex);
          return { ...s, color: color.hex };
        },
    }
  ),
  withPropsOnChange(
    ['value', 'defaultValue'],
    ({ value, defaultValue, setColor, resetColor }) =>
      value ?? defaultValue
        ? setColor({ hex: value ?? defaultValue })
        : resetColor()
  )
)(
  ({
    color,
    isOpen,
    showPicker,
    hidePicker,
    setColor,
    position = 'top',
    isInput = false,
    label,
  }: any) => (
    <div className={cx(styles.root, isOpen && styles.open, styles[position])}>
      <Input
        display-if={isInput}
        value={color}
        wrapperStyle={{ color }}
        label={label}
        onFocus={showPicker}
        iconBefore="tune"
        onChange={() => {}}
      />
      <button
        display-if={!isInput}
        className={styles.button}
        style={{ backgroundColor: color }}
        onClick={showPicker}
      />
      {isOpen && (
        <Picker
          color={color}
          onChangeComplete={setColor}
          onClose={hidePicker}
        />
      )}
    </div>
  )
);

export default withField(ColorPicker);
